export const contactData = [
  {
    label: 'E-mail',
    value: 'digitaleconomy@163.com',
  },
  {
    label: 'Mobile',
    value: '+86 199 4149 0592',
  },
  {
    label: 'Address',
    value: '浙江省杭州市文一西路998号海创园18号楼705',
  },
];

export const location = [
  {
    name: '',
    address: '',
    latlng: {
      lat: 30.279871,
      lng: 120.016526,
    },
    imgList:
      'https://college-official.oss-cn-hangzhou.aliyuncs.com/materials/about/contact/weilaikeji.png',
  },
];
